import { useContext } from 'react';
import { IncludeMethodsContext } from './IncludeMethodsProvider';

export default function useIncludeMethodsContext() {
    return useContext(IncludeMethodsContext);
};
